import React, { useEffect, useState } from "react"
import ContactRow from "./ContactRow"
import { Button } from "react-bootstrap";
import ContactDuplicate from "./ContactDuplicate";

export default function ContactsTable({ contacts, onDeleteContact, mergeInfo }) {
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [showMergeInfo, setShowMergeInfo] = useState(false);
  
  const handleRowInputCheck = (id) => {
    setSelectedContacts(prev => {
      if(prev.includes(id)) return prev.filter(x => x !== id);
      return [...prev, id]
    })
  }

  useEffect(() => {
    if(!mergeInfo) setSelectedContacts([]);
  }, [mergeInfo])
  
  return (
    <div className="table-responsive">
      {selectedContacts.length > 0 && <Button variant="outlined-blue" size="sm" onClick={() => setShowMergeInfo(true)}>Merge</Button>}
      {showMergeInfo && <ContactDuplicate selectedContacts={contacts.filter(x => selectedContacts.includes(x.id))} contacts={contacts} setShowMergeInfo={setShowMergeInfo} />}
      <table className="table table-listing table-hover">
        <thead>
          <tr>
            {mergeInfo && <th></th>}
            <th>Contact Name</th>
            <th>Client Type</th>
            <th>Company</th>
            <th>Related Jobs</th>
            <th>Email</th>
            <th>Phone</th>
          </tr>
        </thead>
        <tbody>
          {contacts.map(contact => <ContactRow key={`table-row-${contact.id}`} contact={contact} onDeleteContact={onDeleteContact} selectedContacts={selectedContacts} handleRowInputCheck={handleRowInputCheck} mergeInfo={mergeInfo} />)}
        </tbody>
      </table>
    </div>
  )
}
